/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */

import { Tooltip } from "antd"


export const TableHiddenMessage = ({message}: {message: string}) => {
  return  <Tooltip title={message}>
  <div className="two-lines-cell">
    {message}
  </div>
</Tooltip>
}